const ferries = {
  ferry: "מַעבּוֹרֶת", // translated
  ferries: "מעבורות", // translated
  selectOriginPort: "בחר את יציאת המקור", // translated
  selectDestPort: "בחר את נמל היעד", // translated
  continue: "לְהַמשִׁיך", // translated
  viewTimetables: "צפה בלוחות הזמנים", // translated
  operator: "מַפעִיל", // translated
  cabin: "תָא", // translated
  cabins: "בקתות", // translated
  place: "מקום", // translated
  places: "מקומות", // translated
  seat: "מושב", // translated
  seats: "מקומות ישיבה", // translated
  seating: "הוֹשָׁבָה", // translated
  deckSpace: "מרחב סיפון", // translated
  compulsory: "חובה", // translated
  departure: "יְצִיאָה", // translated
  total: 'סה"כ', // translated
  back: "חזור", // translated
  next: "הַבָּא", // translated
  duration: "מֶשֶׁך", // translated
  return: "לַחֲזוֹר", // translated
  prebook: "הזמנה מראש", // translated
  travelInfo: "מידע על נסיעות", // translated
  book: "סֵפֶר", // translated
  adults: "מבוגרים", // translated
  child: "יֶלֶד", // translated
  seniors: "קשישים", // translated
  senior: "בָּכִיר", // translated
  to: "ל", // translated
  passenger: "נוֹסֵעַ", // translated
  details: "פרטים", // translated
  currencyForTickets: "המטבע עבור כרטיסים אלה יהיה", // translated
  seatsError: "מספר הנוסעים אינו שווה לקיבולת.", // translated
  title: "כותרת", // translated
  firstName: "שם פרטי", // translated
  lastName: "שם משפחה", // translated
  email: "אימייל", // translated
  phone: "טלפון", // translated
  dateOfBirth: "תאריך לידה", // translated
  groupLeader: "מנהיג הקבוצה", // translated
  isRequired: "נדרש", // translated
  validEmail: "לא אימייל חוקי", // translated
  atLeastOneAdult: "נדרש מבוגר אחד לפחות.", // translated
  atLeastOneSenior: "נדרש בכיר אחד לפחות.", // translated
  toastAlert: "אנא תקן את כל השגיאות בטפסים למטה.", // translated
  backToFerriesList: "חזרה לרשימת המעבורות", // translated
  bestPrice: "המחיר הטוב ביותר", // translated
  fastest: "הכי מהיר", // translated
  beforeDeparture: "לפני המראה", // translated
  perPerson: "לאדם", // translated
  notAvailableForOnlineBooking: "לא זמין להזמנה מקוונת", // translated
  hurryLimitedAvailability: "הזדרז! זמינות מוגבלת", // translated
  berth: "ברט", // translated
  berths: "דגשים", // translated
  sumOfSelectionNotEqualToPersons: "סכום המבחר אינו שווה למספר הנפשות", // translated
  pleaseSelectUpTo: "נא לבחור עד", // translated
  accommodationTypes: "סוגי לינה", // translated
  selectionPrices: "מחירי מבחר", // translated
  yourCurrentTicket: "סוג הכרטיס הנוכחי שלך הוא", // translated
  upgradeTo: "לשדרג ל", // translated
  wouldYouLikeToUpgrade: "האם תרצה לשדרג את סוג הכרטיס שלך?", // translated
  backToTicketTypes: "חזרה לסוגי כרטיסים", // translated
  originPort: "נמל מקור", // translated
  destinationPort: "נמל היעד", // translated
  outboundDate: "תאריך יוצא", // translated
  inboundDate: "תאריך נכנס", // translated
  passengers: "נוסעים", // translated
  hasReturn: "יש חזרה", // translated
  passengersTravelling: "נוסעים שנוסעים", // translated
  passportPlaceOfIssue: "מקום הנפקת הדרכון", // translated
  placeOfBirth: "מקום לידה", // translated
  attemptToBook: "ניסית להזמין בסך הכל", // translated
  passportStartDate: "תאריך התחלה של הדרכון", // translated
  passportNumber: "מספר דרכון", // translated
  seatsWhenYouHave: "מושבים כשיש לך", // translated
  passportExpiryDate: "תאריך תפוגת דרכון", // translated
  withReturn: "עם כרטיסי חזור", // translated
  charactersOnly: "דמויות בלבד", // translated
  pleaseCorrectYourSelection: "אנא תקן את בחירתך", // translated
  latinCharactersAndSpacesOnly: "תווים ורווחים לטיניים בלבד", // translated
  cityCode: "קוד עיר", // translated
};

export default ferries;
